<template>
    <div>
        <div class="video_meet">
            <div v-if="loading" class="video_loader"></div>
            <div class="video_section">
                <div class="video_block" v-show="azureReady" :class="{'small':videoType == 'local' && ['STARTED', 'ENDED'].indexOf(checkProperty(joinCallStatus, 'phase'))>-1 && !showRemoteTempPic}" @click="toggleActive('remote')">
                    <div ref="localVideo" id="localVideo_localVideo" >
                        <!-- <h2>Local Video</h2> -->
                    </div>
                </div>
                <div class="video_block" :class="{'small':videoType == 'remote'&& ['STARTED', 'ENDED'].indexOf(checkProperty(joinCallStatus, 'phase'))>-1&& !showRemoteTempPic}" @click="toggleActive('local')">
                    <div ref="remoteVideo" id="remoteVideo_remoteVideo">
                        <!-- <h2>Remote Video</h2> -->
                    </div>
                </div>
                <div class="local_video" v-show="enableTempCam && !azureReady">
                    <video ref="video" autoplay class="video-flip"></video>  
                </div>
            </div>
        </div>
        <div v-if="isConnecting" class="connecting_wrapper">
            <span class="connecting_text">Waiting for other to join...</span>
        </div>
        <div class="video_controls">
           <ul>
                <!-- <li>
                    <span>
                        <svg fill="#fff" width="20px" height="20px" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                            <g id="SVGRepo_bgCarrier" stroke-width="0" />
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                                <path
                                    d="M 7.8086 50.3477 L 48.1914 50.3477 C 53.0663 50.3477 55.5508 47.9102 55.5508 43.0820 L 55.5508 18.5430 C 55.5508 13.7149 53.0663 11.3008 48.1914 11.3008 L 42.7069 11.3008 C 40.8789 11.3008 40.3164 10.9258 39.2617 9.7539 L 37.3633 7.6445 C 36.2149 6.3555 35.0196 5.6523 32.5820 5.6523 L 23.2539 5.6523 C 20.8398 5.6523 19.6445 6.3555 18.4727 7.6445 L 16.5742 9.7539 C 15.5430 10.9023 14.9571 11.3008 13.1289 11.3008 L 7.8086 11.3008 C 2.9336 11.3008 .4492 13.7149 .4492 18.5430 L .4492 43.0820 C .4492 47.9102 2.9336 50.3477 7.8086 50.3477 Z M 37.9258 37.5976 L 33.5196 31.7852 C 32.9102 30.9883 33.3086 29.9571 34.2461 29.9571 L 37.4102 29.9571 C 37.4102 24.2383 33.4961 20.2539 27.9883 20.2539 C 26.2539 20.2539 24.8476 20.6758 23.4180 21.4492 C 21.8242 22.2227 20.6055 21.3086 20.6055 20.1602 C 20.6055 19.5976 20.8633 18.9649 21.5430 18.5430 C 23.0430 17.6289 25.3867 16.8320 27.9883 16.8320 C 35.4649 16.8320 40.8789 22.2695 40.8789 29.9571 L 43.6679 29.9571 C 44.6288 29.9571 44.9807 30.9649 44.3711 31.7852 L 39.9414 37.5976 C 39.4492 38.2539 38.4649 38.2773 37.9258 37.5976 Z M 27.9883 42.5898 C 20.5117 42.5898 15.1211 36.8945 15.1211 29.4649 L 12.3320 29.4649 C 11.3476 29.4649 11.0196 28.4336 11.6289 27.6133 L 16.0586 21.8008 C 16.5508 21.1680 17.5352 21.1211 18.0508 21.8008 L 22.4805 27.6133 C 23.0898 28.4336 22.6914 29.4649 21.7305 29.4649 L 18.5664 29.4649 C 18.5664 34.9023 22.4805 39.1445 27.9883 39.1445 C 29.7461 39.1445 31.1758 38.7227 32.5586 37.9727 C 34.1992 37.1523 35.3711 38.1367 35.3711 39.3320 C 35.3711 39.8945 35.0898 40.4336 34.4336 40.8789 C 32.9571 41.8398 30.5664 42.5898 27.9883 42.5898 Z" />
                            </g>
                        </svg>
                    </span>
                </li> -->
                <li v-if="false">
                    <!-- <span @click="toggleVideo()">
                        <svg fill="#ffffff" width="24px" height="24px" viewBox="-4 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"
                            stroke="#ffffff">
                            <g id="SVGRepo_bgCarrier" stroke-width="0" />
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                                <title>video</title>
                                <path
                                    d="M15.5 13.219l6.844-3.938c0.906-0.531 1.656-0.156 1.656 0.938v11.625c0 1.063-0.75 1.5-1.656 0.969l-6.844-3.969v2.938c0 1.094-0.875 1.969-1.969 1.969h-11.625c-1.063 0-1.906-0.875-1.906-1.969v-11.594c0-1.094 0.844-1.938 1.906-1.938h11.625c1.094 0 1.969 0.844 1.969 1.938v3.031z" />
                            </g>
                        </svg>
                    </span> -->
                    <!-- <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19.062" height="19.085" viewBox="0 0 19.062 19.085">
                            <path id="Union_13" data-name="Union 13" d="M2.89,15.8H1.755A1.753,1.753,0,0,1,0,14.048V5.684A1.756,1.756,0,0,1,1.755,3.935H9.734L12.012,0l2.294.848L4.072,19.085Zm5.386,0,4.8-8.622v.077l5.218-2.085a.6.6,0,0,1,.206-.038.555.555,0,0,1,.312.1.568.568,0,0,1,.25.46v8.363a.568.568,0,0,1-.25.46.555.555,0,0,1-.312.1.523.523,0,0,1-.206-.038L13.077,12.48v1.567A1.751,1.751,0,0,1,11.321,15.8Z" transform="translate(-0.001)" fill="#fff"/>
                          </svg>                          
                    </span> -->
                </li>
                <li>
                    <span v-if="isMuted == false"  @click="muteUnmute()">
                        <svg width="20px" height="20px" viewBox="-4 0 24 24" id="meteor-icon-kit__solid-microphone" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0" />
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M8 0C5.23858 0 3 2.23858 3 5V13C3 15.7614 5.23858 18 8 18C10.7614 18 13 15.7614 13 13V5C13 2.23858 10.7614 0 8 0z"
                                    fill="#ffffff" />
                                <path
                                    d="M2 11.5882C2 11.0359 1.55228 10.5882 1 10.5882C0.44772 10.5882 0 11.0359 0 11.5882V13.647C0 17.4729 3.12354 20.4939 7 20.9425V22H5C4.44772 22 4 22.4477 4 23C4 23.5523 4.44772 24 5 24H11C11.5523 24 12 23.5523 12 23C12 22.4477 11.5523 22 11 22H9V20.9425C12.8765 20.4939 16 17.4729 16 13.647V11.5882C16 11.0359 15.5523 10.5882 15 10.5882C14.4477 10.5882 14 11.0359 14 11.5882V13.647C14 16.5143 11.4072 19 8 19C4.59282 19 2 16.5143 2 13.647V11.5882z"
                                    fill="#ffffff" />
                            </g>
                        </svg>
                    </span>
                    <span v-if="isMuted" @click="muteUnmute()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="19.483" viewBox="0 0 13.5 19.483">
                            <path id="Union_11" data-name="Union 11" d="M4.951,19.483a.67.67,0,1,1,0-1.327H6.2V16.49a7.118,7.118,0,0,1-1.317-.255l.764-1.181a5.8,5.8,0,0,0,1.321.151c2.763,0,5.008-1.952,5.008-4.352v-.529a.771.771,0,0,1,1.526,0v.529c0,2.883-2.477,5.305-5.771,5.638v1.665H8.975a.671.671,0,1,1,0,1.327ZM0,15.888l1.32-2.166a5.093,5.093,0,0,1-.9-2.87v-.529a.719.719,0,0,1,.764-.661.719.719,0,0,1,.765.661v.529a3.842,3.842,0,0,0,.265,1.4l1.075-1.765V4.534A3.458,3.458,0,0,1,6.966,1.355a4.126,4.126,0,0,1,1.682.351L9.685,0l2.51.807L1.306,19.04Zm6.365-1.962L10.633,7.28v3.531a3.444,3.444,0,0,1-3.667,3.157A4.451,4.451,0,0,1,6.365,13.927Z" fill="#fff"/>
                        </svg>                          
                    </span>
                </li>
                <li>
                    <span class="callend" @click="endVideoCall()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25.83" height="25.83" viewBox="0 0 25.83 25.83">
                            <path id="Path_71231" data-name="Path 71231" d="M16.8,11.989a10.37,10.37,0,0,1-3.257-.519,1.489,1.489,0,0,0-1.448.305l-2.054,1.55a11.349,11.349,0,0,1-5.1-5.1l1.5-2a1.476,1.476,0,0,0,.363-1.5,10.386,10.386,0,0,1-.521-3.262A1.467,1.467,0,0,0,4.82,0H1.466A1.467,1.467,0,0,0,0,1.466a16.818,16.818,0,0,0,16.8,16.8A1.467,1.467,0,0,0,18.265,16.8V13.454A1.467,1.467,0,0,0,16.8,11.989Z" transform="translate(25.83 12.915) rotate(135)" fill="#fff"/>
                        </svg>                          
                    </span>
                </li>
           </ul>
        </div>
    </div>
</template>
<script>
import { getBrowserId } from '@/utils/browserId.js';
export default {
    name: 'CallComponent',
    data() {
        return {
            azureReady: false,
            loading:false,
            joinCallStatus:null,
            videoType:'local',
            videoCallActivityId:'',
            guId:'',
            videoCallStatus:null,
            browserId:'',
            call: null,
            localVideoStream: null,
            localVideoRenderer: null,
            callId: '29228d3e-040e-4656-a70e-890ab4e173e5',
            isMuted: false,
            isCameraOn: null,
            stream: null,
            intervalId: null,
            enableTempCam:false,
            remoteCheck:null,
            showRemoteTempPic:false,
            isVideoOn: true,
            joinMeetingAccessToken:'',
            streamListeners:[],
            callAgent: null,
            attachedParticipants: new Set(),
            isCallEnding: false,
            isConnecting: false,
        };
    },
    methods: {
        checkConsole(){
            console.log('Camera Off')
        },
        toggleActive(val){
            this.videoType = _.cloneDeep(val)
        },
        startTimer() {
            // console.log('startTimerfdfdfdfd')
            if (this.intervalId === null) {
                this.intervalId = setInterval(this.incrementCounter, 10000);
            }
        },
        stopTimer() {
            console.log('Stop Timer existed')
            if (this.intervalId !== null) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        async incrementCounter() {
            let self = this;
            if (['STARTED'].indexOf(this.checkProperty(this.joinCallStatus, 'phase'))<=-1) {
                await self.joinedCallStatus();
            } else {
                self.stopTimer();
                self.joinCall(true)
            }
        },
        startRemoteVideo(){
            console.log('startRemoteVideo')
            if (this.remoteCheck === null) {
                this.remoteCheck = setInterval(this.checkRemoteVideo, 3000);
            }
        },
        checkRemoteVideo(){
            // console.log('checkRemoteVideo')
            const remoteVid = this.$refs.remoteVideo;
            const allElements = remoteVid.querySelectorAll('*');
            if(!(allElements && allElements.length>0)){
                this.showRemoteTempPic = true;
                this.stopRemoteCheck();
                // console.log('stopRemoteCheck')
            }
            // allElements.forEach(element => {
            //         if(element){
            //             console.log(element)
            //         }
            //     });
        },
        stopRemoteCheck(){
            if (this.remoteCheck !== null) {
                clearInterval(this.remoteCheck);
                this.remoteCheck = null;
            }
        },
        async toggleCamera() {
            this.enableTempCam = true;
            if (this.isCameraOn) {
                this.turnOffCamera();
            } else {
                await this.turnOnCamera();
            }
        },
        async turnOnCamera() {
            try {
                this.stream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.$refs.video.srcObject = this.stream;
                this.isCameraOn = true;
            } catch (error) {
                console.error('Error accessing the camera:', error);
            }
        },
        turnOffCamera() {
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
                this.stream = null;
                this.isCameraOn = false;
                this.$refs.video.srcObject = null;
                this.enableTempCam = false;
            }
            this.enableTempCam = false
        },
        startCall(showTemp = false, startActual = false){
            if(showTemp){
                this.enableTempCam = true;
                this.toggleCamera();
                this.isConnecting = true;
            }
            // else{
            //     this.enableTempCam = true;
            //     this.turnOffCamera();
            // }
            let payLoad={
                entityId:this.checkProperty(this.petitionDetails, '_id'),
                entityType:'i9',
                sessionId:this.browserId
            };
            let path = '/video-call/join';
            this.$store.dispatch('commonAction', {'data':payLoad, 'path':path}).then((res)=>{
                if(this.checkProperty(res, 'guId')){
                    this.guId = res['guId'];
                    if(startActual){
                        this.joinCall()
                    }
                }
                if(this.checkProperty(res, 'videoCallActivityId')){
                    this.videoCallActivityId = res['videoCallActivityId'];
                }
                this.getCallStatus(startActual);
                if(startActual){
                    this.joinedCallStatus()
                }
            }).catch((err)=>{
                this.showToster({ message: err, isError: true });
                this.endVideoCall();
                this.loading = false;
            })
        },
        getCallStatus(startActual = false){
            let payLoad={
                entityId:this.checkProperty(this.petitionDetails, '_id'),
            };
            let path = '/video-call/get-call-status';
            this.$store.dispatch('commonAction', {'data':payLoad, 'path':path}).then((res)=>{
                if(res){ 
                    this.videoCallStatus = res;
                    // Recent changes - Added below if
                    // console.log("videoCallStatus", this.videoCallStatus)
                    if(this.checkProperty(this.videoCallStatus, 'activeParticipants')){
                        // alert('getCallStatus-activeParticipants')
                        const participants = this.videoCallStatus.activeParticipants
                        this.$emit('updateParticipants', participants)
                    }else{
                        this.$emit('updateParticipants', null)
                    }
                    
                }else{
                    this.$emit('updateParticipants', null)
                }
                if(!startActual && this.videoCallStatus && ['STARTED'].indexOf(this.checkProperty(this.videoCallStatus, 'phase'))>-1){
                    console.log('Joined Call')
                    // this.joinCall();
                }
            }).catch((err)=>{

            })
        },
        checkCallStatus(){
            let payLoad={
                entityId:this.checkProperty(this.petitionDetails, '_id'),
            };
            let path = '/video-call/get-call-status';
            this.$store.dispatch('commonAction', {'data':payLoad, 'path':path}).then((res)=>{
                if(res){ 
                    this.videoCallStatus = res;
                    this.startCall(false, true)
                    this.loading = true;
                    console.log("this.videoCallStatus", this.videoCallStatus)
                }else{
                    this.startCall(true);
                    this.startTimer();
                }
            }).catch((err)=>{

            })
        },
        joinedCallStatus(){
            let self = this;
            let payLoad={
                entityId:this.checkProperty(this.petitionDetails, '_id'),
            };
            let path = '/video-call/get-call-status';
            return new Promise((res ,rej)=>{
                self.$store.dispatch('commonAction', {'data':payLoad, 'path':path}).then((resp)=>{
                    if(resp){ 
                        self.joinCallStatus = resp;
                    
                        // Recent changes - Added below if
                        // console.log('joinCallStatus', JSON.stringify(self.joinCallStatus))
                        if(this.checkProperty(self.joinCallStatus, 'activeParticipants')){
                            const participants = self.joinCallStatus.activeParticipants
                            this.$emit('updateParticipants', participants)
                        }else{
                            this.$emit('updateParticipants', null)
                        }
                    }else{
                        this.$emit('updateParticipants', null)
                    }
                    
                    res();
                }).catch((err)=>{
                    rej(err);
                })
            })
        },
        async joinCall(callFromTemp = false) {
            if (this.isCallEnding) {
                console.warn('Call is still ending, rejoin blocked.');
                return; // ✅ Block rejoin until cleanup is complete
            }
            let self = this;
            // console.log(this.guId, 'this.guId')
            // if (!this.guId) {
            //     alert('Please enter a Call ID');
            //     return;
            // }
            try {
                const response = await fetch('https://paf-i9.com/acs/create-user', { method: 'POST' });
                const data = await response.json();

                if (response.ok) {
                    // console.log('execution')
                    const token = data.token;
                    self.joinMeetingAccessToken = data.token;
                    const tokenCredential = new window.AzureCommunicationTokenCredential(token);
                    const callClient = new window.CallClient();
                    self.callAgent = await callClient.createCallAgent(tokenCredential);
                    const callAgent = self.callAgent;

                    const deviceManager = await callClient.getDeviceManager();
                    await deviceManager.askDevicePermission({ audio: true, video: true });

                    const cameras = await deviceManager.getCameras();
                    this.localVideoStream = new window.LocalVideoStream(cameras[0]);
                    const callOptions = {
                        videoOptions: { localVideoStreams: [this.localVideoStream] }
                    };

                    this.call = callAgent.join({ groupId: this.guId }, callOptions);

                    self.turnOffCamera();
                    await self.$nextTick();

                    self.azureReady = true;

                    // Render local video stream
                    this.localVideoRenderer = new window.VideoStreamRenderer(this.localVideoStream);
                    const localView = await this.localVideoRenderer.createView();
                    this.$refs.localVideo.appendChild(localView.target);
                    // console.log('localVideo.appendChild')
                
                    self.showRemoteTempPic = true;
                    self.isVideoOn = true;
                    self.loading = false;
                    self.isConnecting = true;
                    // self.videoType = 'local';

                    // this.call.on('remoteParticipantsUpdated', () => {
                    //     this.call.remoteParticipants.forEach(participant => {
                    //         participant.videoStreams.forEach(async (remoteVideoStream) => {
                    //             const renderer = new window.VideoStreamRenderer(remoteVideoStream);
                    //             const view = await renderer.createView();
                    //             this.$refs.remoteVideo.appendChild(view.target);
                    //             // console.log('remoteVideo.appendChild')
                    //             self.showRemoteTempPic = false;
                    //             self.startRemoteVideo();
                    //             // if(callFromTemp){
                    //             //     self.turnOffCamera();
                    //             // }
                    //         });
                    //     });
                        
                    // });

                    // Attach remote video streams
                    // Helper to attach a participant's remote video stream
                    // ✅ Use component-level Set (not a local one) so de-dup works across re-joins
                    const attachParticipantStream = (participant) => {
                        const participantId = participant.identifier.communicationUserId;

                        if (self.attachedParticipants.has(participantId)) {
                            console.log('Already attached, skipping:', participantId);
                            return; // ✅ Prevent duplicate attachment
                        }
                        self.attachedParticipants.add(participantId);

                        const handleStream = async (remoteVideoStream) => {
                            if (!remoteVideoStream.isAvailable) return;
                            const renderer = new window.VideoStreamRenderer(remoteVideoStream);
                            const view = await renderer.createView();
                            self.$refs.remoteVideo.innerHTML = '';
                            self.$refs.remoteVideo.appendChild(view.target);
                            self.showRemoteTempPic = false;
                            self.isConnecting = false;
                            self.startRemoteVideo();
                        };

                        participant.videoStreams.forEach(stream => {
                            if (stream.isAvailable) {
                                handleStream(stream);
                            }
                            const isAvailableHandler = () => {
                                if (stream.isAvailable) {
                                    handleStream(stream);
                                } else {
                                    self.$refs.remoteVideo.innerHTML = '';
                                    self.showRemoteTempPic = true;
                                }
                            };
                            stream.on('isAvailableChanged', isAvailableHandler);
                            self.streamListeners.push({ stream, isAvailableHandler }); // ✅ Track listener
                        });

                        participant.on('stateChanged', () => {
                            console.log('Participant state changed:', participant.state);
                            if (participant.state === 'Disconnected') {
                                self.attachedParticipants.delete(participantId); // ✅ Clean up on disconnect
                                const activeParts = self.call.remoteParticipants.filter(
                                    p => p.state !== 'Disconnected'
                                );
                                if (activeParts.length === 0) {
                                    self.endVideoCall();
                                }
                            }
                        });
                    };

                    // Handle participants already in the call when you join
                    this.call.remoteParticipants.forEach(participant => {
                        console.log('Already in call participant found:', participant);
                        attachParticipantStream(participant);
                    });

                    // Handle participants who join or leave after you
                    this.call.on('remoteParticipantsUpdated', (e) => {
                        // Participant joined after you
                        e.added.forEach(participant => {
                            console.log('Participant added:', participant);
                            attachParticipantStream(participant);
                        });

                        // Participant left cleanly
                        e.removed.forEach(participant => {
                            console.log('Participant removed, remaining:', self.call.remoteParticipants.length);
                            if (self.call.remoteParticipants.length === 0) {
                                console.log('All participants left (removed). Ending call...');
                                self.endVideoCall();
                            }
                        });
                    });

                    // Add event listeners for debugging
                    this.call.on('callStateChanged', (e) => {
                        console.log(`Call state changed: ${this.call.state}`);
                        if (this.call.state === 'Disconnected') {
                            console.error(`Call disconnected: ${this.call.callEndReason.code}, ${this.call.callEndReason.subCode}`);
                        }
                    });

                    this.call.on('error', (e) => {
                        console.error('Call error:', e);
                    });

                } else {
                    alert(`Error: ${data.error}`);
                }
            } catch (error) {
                console.error('Error joining call:', error);
            }
        },
        muteUnmute() {
            if (this.call && this.localVideoStream) {
                if (this.isMuted) {
                    this.call.unmute();
                    this.isMuted = false;
                } else {
                    this.call.mute();
                    this.isMuted = true;
                }
            }
        },
        async endVideoCall() {
            if (this.isCallEnding) return; // ✅ Prevent double execution
            this.isCallEnding = true;
            this.loading = true;
            this.azureReady = false;
            if (this.call) {
                this.call.hangUp();
                if (this.localVideoRenderer) {
                    this.localVideoRenderer.dispose();
                }
                // ✅ Dispose callAgent so the old Azure connection is fully torn down
                // Without this, the ghost callAgent stays alive and fires duplicate events on re-join
                if (this.callAgent) {
                    try {
                        await this.callAgent.dispose();
                    } catch(e) {
                        console.warn('Error disposing callAgent:', e);
                    }
                    this.callAgent = null;
                }
                this.$refs.localVideo.innerHTML = '';
                this.$refs.remoteVideo.innerHTML = '';
                this.call = null;
                this.localVideoStream = null;
                this.localVideoRenderer = null;
            }
                // ✅ Reset attachedParticipants so re-joins start fresh
            this.streamListeners.forEach(({ stream, isAvailableHandler }) => {
                try {
                    stream.off('isAvailableChanged', isAvailableHandler);
                } catch(e) {
                    console.warn('Error removing stream listener:', e);
                }
            });
            this.streamListeners = [];
            this.attachedParticipants = new Set();
            if(this.videoCallActivityId){
                this.endCall();
            }
            this.showRemoteTempPic = false;
            this.isConnecting = false;
            this.stopRemoteCheck();
            this.turnOffCamera();
            this.stopTimer()
            setTimeout(()=>{
                this.isCallEnding = false;
                this.$emit('endVideoCall')
            },2000)
            
        },
        endCall(){
            let payLoad={
                videoCallActivityId:this.videoCallActivityId
            };
            if(this.browserId){
                payLoad['sessionId'] = this.browserId
            }
            
            let path = '/video-call/end';
            this.$store.dispatch('commonAction', {'data':payLoad, 'path':path}).then((res)=>{
                // Recent changes - Added below
                this.getCallStatus();
            }).catch((err)=>{

            })
        },
        async toggleVideo() {
            if (this.call && this.localVideoStream) {
                // console.log('end')
                if (this.isVideoOn) {
                    // console.log('endStart')
                    this.localVideoStream.switchSource(null);
                    if (this.localVideoRenderer) {
                        this.localVideoRenderer.dispose();
                    }
                    this.$refs.localVideo.innerHTML = '';
                    this.isVideoOn = false;
                } else {
                    // this.joinCall()
                    if(this.joinMeetingAccessToken){
                        this.reJoinVideoCall();
                    }
                    // const deviceManager = await this.callClient.getDeviceManager();
                    // const cameras = await deviceManager.getCameras();
                    // this.localVideoStream = new LocalVideoStream(cameras[0]);
                    // this.localVideoRenderer = new VideoStreamRenderer(this.localVideoStream);
                    // const localView = await this.localVideoRenderer.createView();
                    // this.$refs.localVideo.appendChild(localView.target);
                }
                // this.isVideoOn = !this.isVideoOn;
            }
        },
        async reJoinVideoCall(){
            // console.log('reJoinVideoCall')
            const token = this.joinMeetingAccessToken;
            // console.log(token, 'token')
            // console.log(this.guId, 'token')
            const tokenCredential = new window.AzureCommunicationTokenCredential(token);
            const callClient = new window.CallClient();
            this.callAgent = await callClient.createCallAgent(tokenCredential);
            const callAgent = this.callAgent;

            const deviceManager = await callClient.getDeviceManager();
            await deviceManager.askDevicePermission({ audio: true, video: true });

            const cameras = await deviceManager.getCameras();
            this.localVideoStream = new window.LocalVideoStream(cameras[0]);
            const callOptions = {
                videoOptions: { localVideoStreams: [this.localVideoStream] }
            };

            this.call = callAgent.join({ groupId: this.guId }, callOptions);

            // Render local video stream
            this.localVideoRenderer = new window.VideoStreamRenderer(this.localVideoStream);
            const localView = await this.localVideoRenderer.createView();
            this.$refs.localVideo.appendChild(localView.target);
            this.isVideoOn = true;
            // console.log('reJoinVideoCall this.isVideoOn = true;')
        },
    },
    beforeDestroy() {
        // ✅ Remove all stream listeners
        this.streamListeners.forEach(({ stream, isAvailableHandler }) => {
            try {
                stream.off('isAvailableChanged', isAvailableHandler);
            } catch(e) {
                console.warn('Error removing stream listener:', e);
            }
        });
        this.streamListeners = [];
        this.turnOffCamera();
        this.endVideoCall();
        this.loading = false;
    },
    created() {
        this.browserId = getBrowserId();
    },
    props:{
        petitionDetails:{
            type:Object,
            default:null
        }
    },
    mounted(){
        this.loading = false;
        this.turnOffCamera();
    }
};
</script>
<style scoped>
    .video-flip {
        transform: scaleX(-1);
    }
    .connecting_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 0;
        background: #04265D;
    }
    .connecting_text {
        color: #ffffff;
        font-size: 14px;
        letter-spacing: 0.5px;
        animation: blink 1.2s ease-in-out infinite;
    }
    @keyframes blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.3; }
    }
</style>
